'use client';

import { useEffect, useState } from 'react';
import { MOBILE_MAX_WIDTH } from '@/app/stylesguides';

export function useIsDesktop() {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const mq = window.matchMedia(`(min-width: ${MOBILE_MAX_WIDTH}px)`);

    const update = () => setIsDesktop(mq.matches);
    update();

    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);

  return isDesktop;
}
